module.exports = __webpack_public_path__ + "img/icn-card.cbc7c75b.png";